<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Despachar</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<p class="text-muted"><i class="fa fa-circle-info"></i>Al solicitar se tiene la cantidad del mes correspondiente al año pasado más un <b>{{percentage*100}}%</b> cómo cantidad máxima.
					<span *ngIf="orderShowed.climb">Puedes habilitar o deshabilitar la restricción al hacer click sobre <i class="fa fa-unlock"></i> / <i class="fa fa-lock"></i></span></p>
					<div class="table-responsive">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th colspan="7"
										style="padding: 3px;"
										[style.background]="getGradientColor()"
										>
									</th>
								</tr>
								<tr>
									<th>
										Producto
									</th>
									<th>
										Proveedor
									</th>
									<th class="td-center">
										Usuario
									</th>
									<th class="td-center">
										Estado
									</th>
									<th class="td-center">
										Cantidad
									</th>
									<th>
										Existencias por Bodega
									</th>
									<th class="td-center">
										Solicitado
										<i
										placement="bottom"
											[tooltip]="locked?'Elimina la restricción de porcentaje':'Bloquea para restringir al porcentaje'"
										*ngIf="orderShowed.climb" [ngClass]="locked?'fa-lock':'fa-unlock'" (click)="lockUnlock()" class="clickeable fa"></i>
									</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let product of orderShowed['items']">
									<tr>
										<td>
											<i [tooltip]="seeing[product.productData.id]?'Ocultar datos del producto':'Mostrar datos del producto'"
												(click)="showOrHide(product)"
												[ngClass]="seeing[product.productData.id]?'fa-eye-slash':'fa-eye'"
												class="clickeable fa"></i>
											{{product.productData.name}}
										</td>
										<td>
											<div class="input-group input-group-sm">
												<app-input-autocomplete
													[filterElements]="product['provider'].filterElements"
													[allBorderRadius]="true" [inputs]="product['provider']"
													(getTitle)="$event.filterElement.title = $event.filterElement.nit + ' - '+ $event.filterElement.name"
													[placeholder]="'Ingresa un proveedor'"
													(inputMethod)="writeProvider($event.event.target.value,product['provider'])"
													(changeStatus)="selectProvider($event.filterElement, product['provider'])">
												</app-input-autocomplete>
											</div>
										</td>
										<td class="td-center" valing="center">{{product.updatedByData.email}}</td>
										<td class="td-center" valing="center">{{product.statusName}}</td>
										<td class="td-center" valing="center">{{product.quantity}}</td>
										<td class="td-center">
											<div class="input-group input-group-sm">
												<label for="warehouse" class="input-group-text">
													<span>
														<i [tooltip]="warehouseObjects[product.productData.id]?.existence=='--'?'Ingresa una bodega primero':''"
															class="fa fa-box" style="margin-right: 5px;">
														</i>{{warehouseObjects[product.productData.id].existence}}
													</span>
												</label>
												<app-input-autocomplete
													[filterElements]="warehouseObjects[product.productData.id].filterElements"
													[typeElements]="'warehouse'" [allBorderRadius]="false"
													[placeholder]="'Ingresa una bodega'"
													[inputs]="warehouseObjects[product.productData.id]"
													(inputMethod)="writeWarehouse(warehouseObjects[product.productData.id], product)"
													(getTitle)="$event.filterElement.title = $event.filterElement.name"
													(changeStatus)="selectWarehouse($event.filterElement,warehouseObjects[product.productData.id],product)"></app-input-autocomplete>
											</div>
										</td>
										<td class="td-center" style="max-width: 150px;">
											<div class="form-group">
												<div class="input-group">
													<label for="polishOff" *ngIf="product['error']"
														class="input-group-text bg-danger" style="font-size: 0.8rem;"
														[placement]="'bottom'"
														[tooltip]="product['error']?product['error']:''">
														<i class="fa fa-warning"></i>
													</label>
													<input (input)="checkingPolishOff($event, product)" [class.error-border]="product.quantity < product['polishOff'] 
													|| (product.max && product.max < product['polishOff'])"
														style="text-align: center;" type="number" name="polishOff"
														max="{{product.quantity}}" id="polishOff" min="0" step="1"
														[(ngModel)]="product['polishOff']" class="form-control">
												</div>
											</div>
										</td>
									</tr>
									<tr *ngIf="seeing[product.productData.id]" style="padding: 1rem;">
										<td colspan="7" *ngIf="product['history']">
											<div id="apex-spline-area-chart-{{product.productData.id}}"></div>
										</td>
										<td colspan="7" *ngIf="!product['history']">
											<span class="spinner-border spinner-border-sm"></span>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<p class="text-muted"><i class="fa fa-circle-info"></i>Ingresa todos los campos obligatorios</p>
						<button class="btn btn-danger" (click)="anulateOrder()" [disabled]="anulating || saving">
							<i *ngIf="!anulating" class="fa-solid fa-ban"></i>
							<span *ngIf="anulating" class="spinner-border spinner-border-sm"
								aria-hidden="true"></span>ANULAR PEDIDO</button>
						<ng-container *ngIf="!anItemhasErrorMax()">
							<!-- <button class="btn btn-info" (click)="downloadOrders()"
								[disabled]="disabledSave() || anulating || saving || downloading">
								<span *ngIf="!downloading" class="notification-container"><i
										class="fa-solid fa-download"></i><span class="notification-icon"
										*ngIf="getUniqueProviderIds()>0">{{getUniqueProviderIds()}}</span></span>
								<span *ngIf="downloading" class="spinner-border spinner-border-sm"
									aria-hidden="true"></span>DESCARGAR</button> -->
							<button class="btn btn-success" (click)="confirmChanges()"
								[disabled]="disabledSave() || saving || anulating">
								<i *ngIf="!saving" class="fa-solid fa-save"></i>
								<span *ngIf="saving" class="spinner-border spinner-border-sm"
									aria-hidden="true"></span>GUARDAR CAMBIOS</button>
						</ng-container>
						<ng-container *ngIf="anItemhasErrorMax()">
							<button class="btn btn-info" (click)="confirmTranslate()"
								[disabled]="saving || anulating">
								<i *ngIf="!saving" class="fa-solid fa-circle-arrow-up"></i>
								<span *ngIf="saving" class="spinner-border spinner-border-sm"
									aria-hidden="true"></span>ESCALAR</button>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>